import * as React from 'react';
import { FC } from 'react';

import { useGeolocation } from 'state/geolocation';

import GeolocationDeniedModal from './geolocation-denied-modal/geolocation-denied-modal';
import GeolocationGrantedModal from './geolocation-granted-modal/geolocation-granted-modal';
import { IGeolocationPermissionModalProps } from './types';

/**
 *
 * GeolocationPermissionModal contains logic required to render UI
 *  view is split from this component to enable separate logic
 *  between web and app -> specifically, logic around opening
 *  native settings. also some copy differences
 *
 */
const GeolocationPermissionModal: FC<IGeolocationPermissionModalProps> = ({
  isOpen,
  dismissModal,
}) => {
  const { isPermissionDenied } = useGeolocation();

  return isPermissionDenied ? (
    <GeolocationDeniedModal isOpen={isOpen} dismissModal={dismissModal} />
  ) : (
    <GeolocationGrantedModal isOpen={isOpen} dismissModal={dismissModal} />
  );
};

export default GeolocationPermissionModal;
